import * as types from '../../action-types';
import {addEducation as initialState } from "../../initialState";

const addEducation = (state=initialState, action) => {
  switch (action.type) {
    case types.ADD_EDUCATION_START:
      return {
        ...state,
        isLoading: true
      };
    case types.ADD_EDUCATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.ADD_EDUCATION_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.ADD_EDUCATION_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default addEducation;
